import React, { useCallback, useEffect, useState } from 'react'
import { Copy } from 'lucide-react'
import CCService from '../../services/httpServiceWithoutSuperAdmin';

function formatMs(epochMs) {
    try {
        return new Date(Number(epochMs)).toLocaleString();
    } catch {
        return "-";
    }
}

const styles = {
    pageWrap: { padding: 24 },
    container: {
        maxWidth: 1024,
        margin: "0 auto",
        fontFamily:
            "Inter, Roboto, system-ui, -apple-system, 'Segoe UI', 'Helvetica Neue', Arial",
    },

    // header
    headerRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 24,
    },
    titleWrap: {},
    title: { fontSize: 20, fontWeight: 600, margin: 0 },
    subtitle: { fontSize: 13, color: "#6B7280", marginTop: 6 },

    // search area
    searchRow: { display: "flex", alignItems: "center", gap: 12 },
    searchInput: {
        padding: "8px 10px",
        borderRadius: 8,
        border: "1px solid #E5E7EB",
        outline: "none",
        fontSize: 14,
    },
    newBtn: {
        padding: "8px 12px",
        borderRadius: 8,
        backgroundColor: "#4F46E5",
        color: "#fff",
        border: "none",
        cursor: "pointer",
        fontWeight: 600,
    },

    // table card
    card: {
        background: "#fff",
        borderRadius: 10,
        boxShadow: "0 6px 18px rgba(15,23,42,0.06)",
        overflow: "hidden",
    },
    table: { width: "100%", borderCollapse: "collapse", tableLayout: "auto" },
    thead: { background: "#F1F5F9" },
    th: {
        textAlign: "left",
        padding: "12px 16px",
        fontSize: 13,
        fontWeight: 600,
    },
    td: { padding: "12px 16px", verticalAlign: "top", fontSize: 14 },

    // table states
    emptyRow: { padding: 24, textAlign: "center", color: "#64748B" },
    loadingRow: { padding: 24, textAlign: "center", color: "#64748B" },

    // actions
    actionBtn: {
        padding: "6px 10px",
        borderRadius: 8,
        border: "1px solid rgba(0,0,0,0.06)",
        background: "#fff",
        cursor: "pointer",
        fontSize: 13,
    },
    deleteBtn: {
        padding: "6px 10px",
        borderRadius: 8,
        border: "1px solid rgba(0,0,0,0.06)",
        background: "#fff",
        cursor: "pointer",
        fontSize: 13,
        color: "#DC2626",
    },
    copyIconBtn: {
        padding: "6px",
        borderRadius: 6,
        border: "1px solid rgba(0,0,0,0.06)",
        background: "#fff",
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
    },

    // footer / pagination
    footerRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 16px",
        borderTop: "1px solid #F1F5F9",
        background: "#F8FAFC",
    },
    pageSizeSelect: {
        padding: "6px 8px",
        borderRadius: 6,
        border: "1px solid #E5E7EB",
        outline: "none",
    },
    pagerBtn: {
        padding: "6px 10px",
        borderRadius: 6,
        border: "1px solid rgba(0,0,0,0.06)",
        background: "#fff",
        cursor: "pointer",
    },

    // modal shared
    modalBackdrop: {
        position: "absolute",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
    },
    modalWrap: {
        position: "fixed",
        inset: 0,
        zIndex: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
    },
    modalCard: {
        position: "relative",
        background: "#fff",
        borderRadius: 10,
        width: "100%",
        maxWidth: 560,
        padding: 20,
        boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
        zIndex: 60,
    },

    // modal form
    formGroup: { marginBottom: 12 },
    label: { display: "block", fontSize: 13, marginBottom: 6, fontWeight: 600 },
    input: {
        width: "100%",
        padding: "8px 10px",
        borderRadius: 8,
        border: "1px solid #E5E7EB",
        boxSizing: "border-box",
        fontSize: 14,
    },
    errorText: { color: "#DC2626", fontSize: 13, marginTop: 6 },

    // confirm modal
    confirmActions: {
        display: "flex",
        justifyContent: "flex-end",
        gap: 12,
        marginTop: 12,
    },
};

const Referal = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    const [pageSize, setPageSize] = useState(10);
    const [offset, setOffset] = useState(0);
    const [totalCount, setTotalCount] = useState(null);

    const [openModal, setOpenModal] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentReferralId, setCurrentReferralId] = useState(null);

    const [events, setEvents] = useState([]);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [selectedEventId, setSelectedEventId] = useState("");
    const [selectedPage, setSelectedPage] = useState("");
    const [formError, setFormError] = useState("");
    const [generating, setGenerating] = useState(false);
    const [generatedLink, setGeneratedLink] = useState("");
    const [successMsg, setSuccessMsg] = useState("");
    const [q, setQ] = useState("");
    const services = new CCService();

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await services.get("/ahead/explore");
                const data = response?.items ?? response;
                setEvents(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error("Error fetching events:", error);
            }
        };

        fetchEvents();
    }, []);

    const fetchReferrals = useCallback(
        async (opts = {}) => {
            setLoading(true);
            setFormError("");
            try {
                const limit = opts.limit ?? pageSize;
                const off = opts.offset ?? offset;
                const params = new URLSearchParams();
                params.set("limit", limit);
                params.set("offset", off);

                if (q) {
                    params.set("q", q);
                }

                const res = await services.get("/ahead/all-referral-link?" + params.toString());
                const payload = res?.data ?? res;

                let list = [];
                let total = null;
                if (Array.isArray(payload)) {
                    list = payload;
                } else if (Array.isArray(payload?.items)) {
                    list = payload.items;
                    total = payload.total ?? payload.count ?? null;
                } else if (Array.isArray(payload?.referrals)) {
                    list = payload.referrals;
                    total = payload.total ?? payload.count ?? null;
                } else {
                    list = [];
                }

                setItems(list);
                setTotalCount(total);
            } catch (err) {
                console.error("fetch referrals error", err);
                setFormError("Failed to load referrals");
            } finally {
                setLoading(false);
            }
        },
        [pageSize, offset, q]
    );

    useEffect(() => {
        setOffset(0);
        fetchReferrals({ offset: 0, limit: pageSize });
    }, [q, pageSize]);

    useEffect(() => {
        fetchReferrals({ offset, limit: pageSize });
    }, [offset]);

    const openCreate = () => {
        setIsEditMode(false);
        setCurrentReferralId(null);
        setName("");
        setEmail("");
        setSelectedEventId("");
        setSelectedPage("");
        setGeneratedLink("");
        setSuccessMsg("");
        setFormError("");
        setOpenModal(true);
    };

    const openEdit = (referral) => {
        setIsEditMode(true);
        setCurrentReferralId(referral?.id ?? referral?.uuid);
        const e = referral?.email_id ?? referral?.email ?? "";
        setEmail(e);
        setName("");
        setSelectedEventId("");
        setSelectedPage("");
        setGeneratedLink("");
        setSuccessMsg("");
        setFormError("");
        setOpenModal(true);
    };

    const onClose = () => {
        setOpenModal(false);
    };

    const validateEmail = (e) => {
        return /^\S+@\S+\.\S+$/.test(e);
    };

    const onGenerate = async () => {
        setFormError("");
        setSuccessMsg("");
        setGeneratedLink("");

        if (isEditMode) {
            // Edit mode validation
            if (!email) {
                setFormError("Please enter an username.");
                return;
            }
            if (!selectedEventId && !selectedPage) {
                setFormError("Please select either an event or a page.");
                return;
            }
        } else {
            // Add mode validation
            if (!name) {
                setFormError("Please enter a name.");
                return;
            }
            if (!email) {
                setFormError("Please enter an username.");
                return;
            }
            if (!selectedEventId && !selectedPage) {
                setFormError("Please select either an event or a page.");
                return;
            }
        }

        setGenerating(true);
        try {
            const payload = {
                email_id: email,
                ...(selectedEventId && { event_id: selectedEventId }),
                ...(selectedPage && { page: selectedPage })
            };

            // Add name only for new user creation
            if (!isEditMode) {
                payload.name = name;
            }

            const endpoint = isEditMode
                ? "/ahead/updateReferralLink"
                : "/ahead/createReferralLink";
            console.log("payload", payload);
            const res = isEditMode ? await services.put(endpoint, payload) : await services.post(endpoint, payload);
            const data = res?.data ?? res;
            const referralLink = data?.referral_link ?? data?.referralLink ?? "";
            const message = data?.message ?? "";

            if (!referralLink) {
                throw new Error("Unexpected response from server");
            }

            if (isEditMode) {
                // Update existing item in list
                setItems((prev) => {
                    return prev.map((item) => {
                        if ((item.email_id ?? item.email) === email) {
                            return {
                                ...item,
                                referral_link: referralLink,
                                referralLink: referralLink,
                                updated_at: new Date().toISOString(),
                            };
                        }
                        return item;
                    });
                });
            } else {
                // Add new item to list
                const newItem = {
                    email_id: email,
                    email: email,
                    name: name,
                    referral_link: referralLink,
                    referralLink: referralLink,
                    uuid: data?.uuid ?? "",
                    booking_count: data?.booking_count ?? 0,
                    created_at: new Date().toISOString(),
                    updated_at: new Date().toISOString(),
                };
                setItems((prev) => [newItem, ...prev]);
            }

            setGeneratedLink(referralLink.replace(/ /g, "%20"));
            setSuccessMsg(message || (isEditMode ? "Referral link updated." : "Referral link created."));
        } catch (err) {
            console.error("generate referral error", err);
            const message = err?.response?.data?.message ?? err.message ?? "Failed to generate link";
            setFormError(message);
        } finally {
            setGenerating(false);
        }
    };

    const onCopy = async (link) => {
        if (!link) return;
        try {
            await navigator.clipboard.writeText(link);
            setSuccessMsg("Link copied to clipboard!");
            setTimeout(() => setSuccessMsg(""), 2500);
        } catch {
            setFormError("Unable to copy. Please copy manually.");
        }
    };

    const onCopyFromTable = async (link) => {
        if (!link) return;
        try {
            await navigator.clipboard.writeText(link);
            alert("Link copied to clipboard!");
        } catch {
            alert("Unable to copy. Please copy manually.");
        }
    };

    const canPrev = offset > 0;
    const canNext = items.length === pageSize && (totalCount === null || offset + pageSize < totalCount);

    const gotoPrev = () => setOffset(Math.max(0, offset - pageSize));
    const gotoNext = () => setOffset(offset + pageSize);

    return (
        <div style={styles.pageWrap}>
            <div style={styles.container}>
                <div style={styles.headerRow}>
                    <div style={styles.titleWrap}>
                        <h1 style={styles.title}>Referral</h1>
                        <p style={styles.subtitle}>Manage referral profiles.</p>
                    </div>

                    <div style={styles.searchRow}>
                        <input
                            type="search"
                            placeholder="Search by name or email..."
                            value={q}
                            onChange={(e) => setQ(e.target.value)}
                            style={styles.searchInput}
                        />
                        <button onClick={openCreate} style={styles.newBtn}>
                            + Add User
                        </button>
                    </div>
                </div>

                <div style={styles.card}>
                    <table style={styles.table} aria-label="Organizers table">
                        <thead style={styles.thead}>
                            <tr>
                                <th style={styles.th}>Name</th>
                                <th style={styles.th}>Username</th>
                                <th style={styles.th}>Referral Link</th>
                                <th style={styles.th}>Created</th>
                                <th style={styles.th}>Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {loading && items.length === 0 ? (
                                <tr>
                                    <td colSpan="5" style={styles.loadingRow}>
                                        Loading…
                                    </td>
                                </tr>
                            ) : items.length === 0 ? (
                                <tr>
                                    <td colSpan="5" style={styles.emptyRow}>
                                        No referrals found.
                                    </td>
                                </tr>
                            ) : (
                                items.map((it) => (
                                    <tr
                                        key={it.id ?? it.email ?? Math.random()}
                                        style={{ borderTop: "1px solid rgba(0,0,0,0.04)" }}
                                    >
                                        <td style={styles.td}>
                                            <div style={{ fontWeight: 600 }}>{it.name ?? "—"}</div>
                                        </td>

                                        <td style={styles.td}>
                                            <div style={{ color: "#64748B", fontSize: 13 }}>{it.email_id ?? "—"}</div>
                                        </td>

                                        <td style={styles.td}>
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <div style={{ color: "#64748B", fontSize: 13, flex: 1, wordBreak: "break-all" }}>
                                                    {it.referral_link?.replace(/ /g, "%20") ?? it.referralLink?.replace(/ /g, "%20") ?? "—"}
                                                </div>
                                                {(it.referral_link || it.referralLink) && (
                                                    <button
                                                        onClick={() => onCopyFromTable(it.referral_link?.replace(/ /g, "%20") ?? it.referralLink?.replace(/ /g, "%20"))}
                                                        style={styles.copyIconBtn}
                                                        title="Copy link"
                                                    >
                                                        <Copy size={16} color="#64748B" />
                                                    </button>
                                                )}
                                            </div>
                                        </td>

                                        <td style={styles.td}>
                                            <div style={{ color: "#64748B", fontSize: 13 }}>
                                                {new Date(it.created_at).toLocaleString('en-US')}
                                            </div>
                                        </td>

                                        <td style={{ ...styles.td }}>
                                            <div style={{ display: "flex", gap: 8 }}>
                                                <button onClick={() => openEdit(it)} style={styles.actionBtn}>
                                                    Edit
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                    <div style={styles.footerRow}>
                        <div style={{ color: "#64748B", fontSize: 13 }}>
                            Showing {items.length} {totalCount ? `of ${totalCount}` : ""} referrals
                        </div>

                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <select
                                value={pageSize}
                                onChange={(e) => {
                                    setPageSize(Number(e.target.value));
                                    setOffset(0);
                                }}
                                style={styles.pageSizeSelect}
                                aria-label="Page size"
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                            </select>

                            <button
                                onClick={gotoPrev}
                                disabled={!canPrev}
                                style={{
                                    ...styles.pagerBtn,
                                    opacity: canPrev ? 1 : 0.5,
                                    cursor: canPrev ? "pointer" : "not-allowed",
                                }}
                            >
                                Prev
                            </button>
                            <button
                                onClick={gotoNext}
                                disabled={!canNext}
                                style={{
                                    ...styles.pagerBtn,
                                    opacity: canNext ? 1 : 0.5,
                                    cursor: canNext ? "pointer" : "not-allowed",
                                }}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal */}
            {openModal && (
                <div style={styles.modalWrap} role="dialog" aria-modal="true" aria-labelledby="referral-modal-title">
                    <div style={styles.modalBackdrop} onClick={onClose} />
                    <div style={styles.modalCard}>
                        <h2 id="referral-modal-title" style={{ margin: 0, marginBottom: 8, fontSize: 18 }}>
                            {isEditMode ? "Update Referral Link" : "Add New User"}
                        </h2>
                        <p style={{ marginTop: 0, color: "#6B7280", marginBottom: 12 }}>
                            {isEditMode
                                ? "Select either an event or a page to update the referral link."
                                : "Enter user details and select either an event or a page to create a referral link."
                            }
                        </p>

                        {!isEditMode && (
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Name</label>
                                <input
                                    style={styles.input}
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    disabled={generating}
                                    placeholder="Enter user's full name"
                                    aria-label="User name"
                                />
                            </div>
                        )}

                        <div style={styles.formGroup}>
                            <label style={styles.label}>Username</label>
                            <input
                                style={styles.input}
                                type="text"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                disabled={generating || isEditMode}
                                placeholder="Enter username"
                                aria-label="Username"
                            />
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>Event</label>
                            <select
                                style={styles.input}
                                value={selectedEventId}
                                onChange={(e) => {
                                    setSelectedEventId(e.target.value);
                                    if (e.target.value) setSelectedPage("");
                                }}
                                disabled={generating || events.length === 0 || selectedPage !== ""}
                                aria-label="Select event"
                            >
                                <option value="">-- Select an event --</option>
                                {events.map((ev) => (
                                    <option key={ev.id ?? ev.event_id ?? ev.value} value={ev.id ?? ev.event_id ?? ev.value}>
                                        {ev.event_name ?? ev.title ?? `Event ${ev.id ?? ev.event_id ?? ""}`}
                                    </option>
                                ))}
                            </select>
                            {selectedPage && (
                                <div style={{ fontSize: 12, color: "#64748B", marginTop: 4 }}>
                                    Disabled because a page is selected
                                </div>
                            )}
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>Page</label>
                            <select
                                style={styles.input}
                                value={selectedPage}
                                onChange={(e) => {
                                    setSelectedPage(e.target.value);
                                    if (e.target.value) setSelectedEventId("");
                                }}
                                disabled={generating || selectedEventId !== ""}
                                aria-label="Select page"
                            >
                                <option value="">-- Select a page --</option>
                                <option value="/ahead">/ahead</option>
                                <option value="/ahead/explore">/ahead/explore</option>
                            </select>
                            {selectedEventId && (
                                <div style={{ fontSize: 12, color: "#64748B", marginTop: 4 }}>
                                    Disabled because an event is selected
                                </div>
                            )}
                        </div>

                        {formError && <div style={styles.errorText}>{formError}</div>}
                        {successMsg && <div style={{ color: "#16A34A", marginTop: 8 }}>{successMsg}</div>}

                        {generatedLink && (
                            <div style={{ marginTop: 12 }}>
                                <label style={styles.label}>Generated Link</label>
                                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                                    <input
                                        style={{ ...styles.input, flex: 1 }}
                                        readOnly
                                        value={generatedLink}
                                        onFocus={(e) => e.target.select()}
                                    />
                                    <button style={styles.actionBtn} onClick={() => onCopy(generatedLink)}>
                                        Copy
                                    </button>
                                </div>
                            </div>
                        )}

                        <div style={styles.confirmActions}>
                            <button
                                onClick={onClose}
                                style={{ ...styles.pagerBtn, background: "#fff", border: "1px solid #E5E7EB" }}
                                disabled={generating}
                            >
                                Cancel
                            </button>

                            <button
                                onClick={onGenerate}
                                style={{
                                    ...styles.newBtn,
                                    padding: "8px 14px",
                                    opacity: generating ? 0.7 : 1,
                                    cursor: generating ? "not-allowed" : "pointer",
                                }}
                                disabled={generating}
                            >
                                {generating ? "Generating…" : (isEditMode ? "Update Link" : "Generate Link")}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Referal